export default __webpack_public_path__ + "static/media/ico-palette-hover.aed9e3ec.svg";